module.exports = __webpack_public_path__ + "media/images/team/Marina-fa13c44c9294a1d399764b50eba53b83.jpg";